<template>
  <div
    v-if="room.user_id"
    class="d-flex align-items-center text-truncate"
  >
    <slot
      v-if="withWho"
      name="before"
    />
    <div class="flex-fill text-truncate">
      <slot
        v-if="withWho"
        name="before-str"
      />
      {{ withWho }}
    </div>
    <div
      v-if="showAvatar"
      class="chat-user-img align-self-center ml-2"
      :class="[isOnline? 'online' : 'offline']"
    >
      <img
        :src="userData.avatar_image_url"
        class="rounded-circle avatar-xs"
        :alt="withWho"
        :title="withWho"
      >
      <span class="user-status" />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {fullName} from "../../../utils/contactName";

export default {
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
    showAvatar: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('auth', ['user']),
    userData() {
      return this.$store.state.user.data[this.room.user_id] || {}
    },
    withWho() {
      const {user_id} = this.room;

      if (!user_id) return ''

      /*if (user_id === this.user.id) {
        const name = this.$t('room.header.reassign.with.me')
        return this.$t('room.header.reassign.with.title_me', {name})
      }*/

      return fullName(this.userData)
    },
    isOnline() {
      const {status} = this.$store.state.user.status[this.room.user_id] || {}
      return status === 1
    },
  },
}
</script>

<style scoped>

</style>
